package uz.ferro.shop.ui.table

import mui.icons.material.Edit
import mui.material.Box
import mui.material.IconButton
import mui.material.Table
import mui.material.TableBody
import mui.material.TableCell
import mui.material.TableHead
import mui.material.TableRow
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.useState
import uz.ferro.shop.Colors
import web.cssom.Position
import web.cssom.Visibility
import web.cssom.px

external interface TableProps : PropsWithChildren, PropsWithSx {
    var headers: List<HeaderItem>
    var items: List<RowItem>
    var enableRowEdit: Boolean
    var onEditClick: (String) -> Unit
    var positionAutoHeight: Boolean?
}

val TableView = FC<TableProps> { props ->
    var hoveredItemKey by useState { "" }
    Table {
        sx {
            if (props.positionAutoHeight != true) {
                position = Position.absolute
                top = 0.px
                right = 0.px
                bottom = 0.px
                left = 0.px
            }
        }

        if (props.positionAutoHeight != true) {
            stickyHeader = true
        }
        TableHead {
            TableRow {
                props.headers.forEach { headerItem ->
                    TableCell {
                        if (headerItem.width != null) {
                            sx {
                                width = 120.px
                            }
                        }

                        +headerItem.title
                    }
                }
            }
        }
        TableBody {
            props.items.forEach { item ->
                TableRow {
                    hover = true
                    key = item.key

                    onMouseOver = {
                        hoveredItemKey = item.key
                    }

                    onMouseOut = {
                        if (hoveredItemKey == item.key) {
                            hoveredItemKey = ""
                        }
                    }

                    if (item.onItemClick != null) {
                        onClick = { evt ->
                            evt.preventDefault()
                            item.onItemClick?.invoke()
                        }
                    }

                    item.cells.forEach { cell ->
                        TableCell {
                            sx {
                                textAlign = cell.textAlign
                            }
                            if (cell.content != null) {
                                +cell.content
                            } else {
                                +cell.title.orEmpty()
                            }
                        }
                    }

                    if (props.enableRowEdit) {
                        TableCell {
                            +""
                        }
                    }

                    if (props.enableRowEdit) {
                        TableCell {
                            Box {
                                IconButton {
                                    sx {
                                        padding = 0.px
                                        visibility = if (hoveredItemKey == item.key) {
                                            Visibility.visible
                                        } else {
                                            Visibility.hidden
                                        }
                                    }
                                    Edit {
                                        htmlColor = Colors.iconSecondary
                                    }
                                    onClick = {
                                        props.onEditClick(item.key)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
